module.exports = __webpack_public_path__ + "img/background-screen-6.6e83092d.svg";